import { enrich } from '@i18n/localizeHelper'
import { regionsTabs } from './constants'
import type { RegionsMunicipalitiesFeatures } from '@schema/featureToggle'

type PageTabTitles = Record<RegionsMunicipalitiesFeatures, string>

export const getRegionPageTitle = (
  tab: RegionsMunicipalitiesFeatures,
  entityName: string,
  pageTabTitles: PageTabTitles,
): string => {
  if (tab === regionsTabs.overview) {
    return entityName
  }
  const template = pageTabTitles[tab]
  if (!template.includes('{0}')) {
    return template
  }
  return enrich(template, entityName)
}
